import React, { useEffect, useState } from 'react';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const REASON_LABELS = [
  { key: 'missedRefillReminder', label: 'Missed refill reminder' },
  { key: 'sideEffectManagement', label: 'Side effect management' },
  { key: 'copayBarrier', label: 'Copay / cost barrier' },
  { key: 'other', label: 'Other reasons' },
];

const StatBox = ({ value, label, valueStyle }) => (
  <div style={{
    flex: 1,
    background: '#F0F4FF',
    borderRadius: 8,
    padding: '12px 16px',
    textAlign: 'center',
  }}
  >
    <p style={{
      margin: '0 0 4px',
      fontSize: 26,
      fontWeight: 700,
      color: '#111827',
      ...valueStyle,
    }}
    >
      {value ?? '-'}
    </p>
    <p style={{ margin: 0, fontSize: 12, color: '#6B7280' }}>{label}</p>
  </div>
);

const formatGrowth = (pct) => {
  if (pct == null) return '-';
  return pct >= 0 ? `+${pct}%` : `${pct}%`;
};

const RecentInterventions = ({ requestData }) => {
  const [recentInterventionsData, setRecentInterventionsData] = useState(null);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getRecentInterventions(requestData);

        setRecentInterventionsData(data);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const breakdown = recentInterventionsData?.reasonBreakdown ?? {};

  return (
    <div className={classes.chart_kpi_wrapper} style={{ padding: 16, minHeight: 276 }}>
      <p style={{
        margin: '0 0 16px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        Recent interventions
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : !recentInterventionsData
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
                <StatBox value={recentInterventionsData.contacted} label="Contacted" />
                <StatBox
                  value={formatGrowth(recentInterventionsData.growthPct)}
                  label="Improved"
                  valueStyle={{ color: recentInterventionsData.growthPct >= 0 ? '#16A34A' : '#DC2626' }}
                />
                <StatBox value={recentInterventionsData.doseReductions} label="Dose reductions" />
              </div>

              <p style={{
                margin: '0 0 10px', fontWeight: 700, fontSize: 13, color: '#111827',
              }}
              >
                Reason breakdown
              </p>

              {REASON_LABELS.map(({ key, label }) => {
                const count = breakdown[key]?.count ?? 0;
                return (
                  <div
                    key={key}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: 13,
                      color: '#374151',
                      marginBottom: 4,
                    }}
                  >
                    <span>{label}</span>

                    <span style={{ fontWeight: 700, color: '#111827' }}>{count}</span>
                  </div>
                );
              })}
            </>
          )}
    </div>
  );
};

export default RecentInterventions;
